import React, { useRef, useEffect } from 'react';
import './DashboardGroups.css'; // Assuming styles are here or I should add new ones

interface IconPickerProps {
  items: any[];
  onSelect: (item: any) => void;
  onClose: () => void;
}

export const IconPicker: React.FC<IconPickerProps> = ({ items, onSelect, onClose }) =>
{
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() =>
  {
    const handleClickOutside = (event: MouseEvent) =>
    {
      if (ref.current && !ref.current.contains(event.target as Node))
      {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () =>
    {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  if (!items || items.length === 0) return null;

  return (
    <div className="icon-picker-container" ref={ref}>
      <div className="icon-picker-header">
        <span>I want to create a</span>
        <span className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}>
          ×
        </span>
      </div>
      <div className="icon-picker-list">
        {items.map((item, index) => (
          <div
            key={item.ConfigValueId || index}
            className="icon-picker-item"
            onClick={() => onSelect(item)}
            title={item.Name}
          >
            <span className={`icon-picker-icon ${item.Icon}`}></span>
            <span className="icon-picker-label">{item.Text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
